import React from 'react';
import { Footer } from 'antd/lib/layout/layout';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Container from 'components/container';
import { baseStyle } from 'components/Layout/styles';
import moment from 'utils/datetime';

const Section = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const StyledFooter = styled(Footer)`
  ${baseStyle};
  background-color: var(--neutral-11);
`;

const StyledLink = styled(Link)`
  margin: 0 1rem;
  color: var(--neutral-6);

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const CopyrightText = styled.div`
  color: var(--text-color-secondary);
`;

const BlackFooter = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <StyledFooter>
      <Container>
        <Section>
          <StyledLink to="terms-and-conditions" data-testid="footer-tnc">
            {t('blackFooter.tnc')}
          </StyledLink>
          <StyledLink to="privacy-policy" data-testid="footer-policy">
            {t('blackFooter.privacyPolicy')}
          </StyledLink>
        </Section>
        <Section>
          <CopyrightText data-testid="footer-copyright">
            {t('blackFooter.copyright', { year: moment(new Date()).year() })}
          </CopyrightText>
        </Section>
      </Container>
    </StyledFooter>
  );
};

export default BlackFooter;
